import React, { InputHTMLAttributes } from 'react'

import { useField } from 'formik'
import classNames from 'classnames'

import { FieldError } from '@components/form/field-error'
import { FieldProps } from '@components/form/types'

import styles from '../../styles.module.scss'
import { removeAccents } from '@utils/remove-accents'

type InputProps = FieldProps &
  Omit<InputHTMLAttributes<HTMLInputElement>, 'onBlur'>

export const InputEmail = ({
  name,
  label,
  className,
  container,
  error,
  withoutError = false,
  leftIcon,
  ...rest
}: InputProps) => {
  const [field, meta, helpers] = useField<string>(name)

  const handleOnChange = (value: string) => {
    helpers.setValue(removeAccents(value))
    field.onChange(name)
  }

  return (
    <div {...container}>
      {label}
      <div
        className={classNames(styles.input, className, {
          [styles.error]: meta.error && meta.touched
        })}
        style={{
          paddingLeft: leftIcon ? '0.5rem' : null
        }}
      >
        {leftIcon && <div>{leftIcon}</div>}
        <input
          name={name}
          {...field}
          onChange={event => handleOnChange(event.target.value)}
          className="w-full"
          {...rest}
        />
      </div>
      {!withoutError && (
        <FieldError touched={meta.touched} error={meta.error} {...error} />
      )}
    </div>
  )
}
